import React from 'react';
import { LoyaltyIndicationBanner, LoyaltyIndicationBannerPointsMode } from '@fiverr-private/loyalty_indication';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { Gql } from '@fiverr-private/loyalty_utils';
import { ROLLOUTS } from '../../types/rollouts';

export interface LoyaltyBannerProps {
  currency: { rate: number; name: string };
  seller: {
    isPro: boolean;
    displayName: string;
  };
  currentPrice: number;
  isCollapsible?: boolean;
  containerStyles?: React.ComponentProps<typeof LoyaltyIndicationBanner>['containerStyles'];
}

export const LoyaltyBanner = ({
  currency,
  seller,
  currentPrice,
  isCollapsible,
  containerStyles,
}: LoyaltyBannerProps) => {
  const { loyaltyIndication = {}, rollouts } = useGigPageContext();
  const isInLoyaltyPointsRollout = rollouts[ROLLOUTS.ZEBRAS_NEW_LOYALTY_POINTS];

  if (isInLoyaltyPointsRollout) {
    return (
      <LoyaltyIndicationBannerPointsMode
        type="gig_page"
        data-testid="loyalty_indication_banner_points_mode"
        loyaltyIndicationData={loyaltyIndication as Gql.EngagementBadgeInfo}
        currency={currency}
        isCollapsible={isCollapsible}
        useTierIcon
        pointsAmount={(loyaltyIndication as Gql.EngagementBadgeInfo & { points: number })?.points || 0}
        containerStyles={containerStyles}
        gigInfo={{
          gigPriceInUSDCents: currentPrice || 0,
          isProSeller: seller?.isPro,
          sellerName: seller?.displayName,
        }}
      />
    );
  }

  return (
    <LoyaltyIndicationBanner
      type="gig_page"
      loyaltyIndicationData={loyaltyIndication as Gql.EngagementBadgeInfo}
      currency={currency}
      isCollapsible={isCollapsible}
      containerStyles={containerStyles}
      gigInfo={{
        gigPriceInUSDCents: currentPrice || 0,
        isProSeller: seller?.isPro,
        sellerName: seller?.displayName,
      }}
    />
  );
};
